module.exports = __webpack_public_path__ + "static/img/8.6ad0053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/8.jpg
// module id = t5Uc
// module chunks = 1